import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import EmployeeAccountCard from '../components/EmployeeAccountCard';
import RecordarSaldoButton from '../components/RecordarSaldoButton';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { GENERAL_STATUS } from '../utils/enums';
import { conditionLabel, stateLabel, creditStatusLabel } from '../utils/usedGame';

var config = process.env;

function money(value) {
    const n = Number(value || 0);
    return `$ ${n.toLocaleString('es-UY')}`;
}

function fmtDate(value) {
    if (!value) return '-';
    return new Date(value).toLocaleString('es-UY');
}

// Detalle de cliente para el admin (ENI-69): perfil + crédito + carrito + favoritos + compras.
// Se llega desde el listado de Clientes ("Ver detalle") o desde el panel de Carritos.
class ClientDetailPage extends Component {

    constructor() {
        super();
        this.state = {
            checked: false, role: 0, cedula: null,
            data: null, loading: true, notFound: false,
            savingEmployee: false,
            savingHost: false,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        const params = new URLSearchParams(this.props.location.search);
        const cedula = params.get('cedula');
        // Un cliente que sólo se registró en la tienda (nunca compró) puede no tener cédula:
        // ahí la clave es el id de su cuenta. Si el detalle devuelve una cédula (porque la
        // cuenta sí la tenía vinculada), se adopta para que "empleado" y el resto funcionen.
        const accountId = params.get('accountId');
        this.setState({ checked: true, role, cedula });
        this.fetchDetail(cedula ? `clients/${encodeURIComponent(cedula)}` : `clients/account/${encodeURIComponent(accountId)}`);
    }

    fetchDetail = (path) => {
        this.setState({ loading: true, notFound: false });
        const request = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + path, request)
            .then((r) => r.json())
            .then((data) => {
                if (data.error > 0) {
                    if (data.error === 1002) { window.location.href = localStorage.getItem('homePageURL'); return; }
                    this.setState({ loading: false, notFound: true });
                } else {
                    this.setState({ data: data.data, loading: false, cedula: data.data.cedula || null });
                }
            })
            .catch(() => this.setState({ loading: false, notFound: true }));
    }

    cartTotal = (items) => (items || []).reduce((acc, it) => acc + Number(it.price || 0) * Number(it.quantity || 0), 0);

    // ENI-111: cataloga/descataloga al cliente como empleado (PATCH /clients/:cedula/employee).
    toggleEmployee = (e) => {
        const isEmployee = e.target.checked;
        const { cedula } = this.state;
        this.setState({ savingEmployee: true });
        const request = {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
            body: JSON.stringify({ isEmployee }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `clients/${cedula}/employee`, request)
            .then((r) => r.json())
            .then((res) => {
                if (res.error > 0) {
                    if (res.error === 1002) { window.location.href = localStorage.getItem('homePageURL'); return; }
                    alert('No se pudo actualizar el estado de empleado.');
                    this.setState({ savingEmployee: false });
                    return;
                }
                // Reflejar el cambio en el perfil local (sin re-fetch).
                this.setState((s) => ({
                    savingEmployee: false,
                    data: s.data ? { ...s.data, profile: { ...(s.data.profile || {}), is_employee: isEmployee ? 1 : 0 } } : s.data,
                }));
            })
            .catch(() => { alert('No se pudo actualizar el estado de empleado.'); this.setState({ savingEmployee: false }); });
    }

    // spec-mesa-abierta FR-070: habilita o deshabilita a la CUENTA de la tienda como anfitrión
    // de mesas abiertas (PATCH /clients/account/:accountId/open-table-host). El permiso es de la
    // cuenta con la que el cliente entra a la web, no de la ficha por cédula.
    toggleHost = (e) => {
        const canHost = e.target.checked;
        const account = this.state.data && this.state.data.account;
        if (!account) return;
        this.setState({ savingHost: true });
        const request = {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'access-token': localStorage.getItem('token') },
            body: JSON.stringify({ canHost }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `clients/account/${account.id}/open-table-host`, request)
            .then((r) => r.json())
            .then((res) => {
                if (res.error > 0) {
                    if (res.error === 1002) { window.location.href = localStorage.getItem('homePageURL'); return; }
                    alert('No se pudo actualizar el permiso de anfitrión.');
                    this.setState({ savingHost: false });
                    return;
                }
                // Se refleja lo que GUARDÓ el backend, no lo que se tildó.
                const saved = !!(res.data && res.data.account && res.data.account.canHostOpenTables);
                this.setState((s) => ({
                    savingHost: false,
                    data: s.data ? { ...s.data, account: { ...(s.data.account || {}), canHostOpenTables: saved } } : s.data,
                }));
            })
            .catch(() => { alert('No se pudo actualizar el permiso de anfitrión.'); this.setState({ savingHost: false }); });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        const { data, cedula } = this.state;
        const profile = (data && data.profile) || {};
        const account = data && data.account;
        const firstName = profile.firstName || (account && account.firstName) || '';
        const lastName = profile.lastName || (account && account.lastName) || '';
        const fullName = [firstName, lastName].filter(Boolean).join(' ') || '(sin nombre)';
        const email = profile.email || (account && account.email) || '-';

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={3} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Clientes" subtitle={cedula ? `Detalle — cédula ${cedula}` : 'Detalle — cliente sin ficha de facturación'} />

                            {this.state.loading && (
                                <div className="card card-small mb-4"><div className="card-body p-4 text-center">Cargando…</div></div>
                            )}

                            {!this.state.loading && this.state.notFound && (
                                <div className="card card-small mb-4">
                                    <div className="card-body p-4">
                                        <h6 className="text-uppercase text-muted">Cliente no encontrado</h6>
                                        <p className="mb-0">{cedula ? `No hay perfil ni cuenta asociada a la cédula ${cedula}.` : 'No se encontró la cuenta de tienda buscada.'}</p>
                                    </div>
                                </div>
                            )}

                            {!this.state.loading && data && (
                                <React.Fragment>
                                    {/* Datos del cliente */}
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom"><h6 className="m-0">Datos del cliente</h6></div>
                                        <div className="card-body p-4">
                                            <div className="row">
                                                <div className="col-md-6 mb-2"><strong>Nombre:</strong> {fullName}</div>
                                                <div className="col-md-6 mb-2"><strong>Correo:</strong> {email}</div>
                                                {/* El teléfono se buscaba SOLO en la ficha de facturación, que no existe para
                                                    quien nunca compró. Se cae a la cuenta de la tienda, que es donde queda el
                                                    móvil que dejó al reservar una mesa. */}
                                                <div className="col-md-6 mb-2"><strong>Teléfono:</strong> {profile.phone || (account && account.phone) || '-'}</div>
                                                <div className="col-md-6 mb-2"><strong>Cédula:</strong> {cedula ? <React.Fragment>{cedula} {account ? (account.cedulaVerified ? '✓ verificada' : '(sin verificar)') : ''}</React.Fragment> : <span className="text-muted">Sin cédula — todavía no compró</span>}</div>
                                                <div className="col-md-6 mb-2"><strong>Dirección:</strong> {profile.address || '-'}{profile.city ? `, ${profile.city}` : ''}</div>
                                                <div className="col-md-6 mb-2"><strong>Cuenta (login):</strong> {account ? `Sí — alta ${fmtDate(account.createdAt)}` : 'No tiene cuenta en la tienda'}</div>
                                            </div>
                                            {/* ENI-111: catalogar como empleado (solo si existe perfil en `user`). */}
                                            {data.profile && (
                                                <div className="row border-top pt-3 mt-1">
                                                    <div className="col-md-12">
                                                        <label style={{ cursor: 'pointer', marginBottom: 0 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={Number(profile.is_employee) === 1}
                                                                disabled={this.state.savingEmployee}
                                                                onChange={this.toggleEmployee}
                                                            />
                                                            {' '}<strong>Empleado</strong>
                                                            <span className="text-muted"> — accede al precio de empleado en las ventas de cafetería</span>
                                                            {this.state.savingEmployee && <span className="text-muted"> · guardando…</span>}
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                            {/* spec-mesa-abierta FR-070: anfitrión de mesas abiertas. Sólo si
                                                tiene cuenta en la tienda: es con esa cuenta que publica. */}
                                            {account && (
                                                <div className="row border-top pt-3 mt-1">
                                                    <div className="col-md-12">
                                                        <label style={{ cursor: 'pointer', marginBottom: 0 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!account.canHostOpenTables}
                                                                disabled={this.state.savingHost}
                                                                onChange={this.toggleHost}
                                                            />
                                                            {' '}<strong>Anfitrión de mesas abiertas</strong>
                                                            <span className="text-muted"> — puede abrir sus propias mesas abiertas desde la web</span>
                                                            {this.state.savingHost && <span className="text-muted"> · guardando…</span>}
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Crédito en tienda. Se lleva POR CÉDULA: para un cliente que
                                        todavía no compró no hay saldo que mostrar, y poner $0 sería
                                        afirmar un dato que nadie calculó. */}
                                    <div className="card card-small mb-4">
                                        <div className="card-body p-4 d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="text-uppercase text-muted mb-1">Crédito en tienda</h6>
                                                {cedula
                                                    ? <h3 className="mb-0">{money(data.storeCredit)}</h3>
                                                    : <p className="mb-0 text-muted">Se habilita cuando el cliente tenga cédula (primera compra).</p>}
                                            </div>
                                            {cedula && (
                                                <div className="d-flex align-items-start">
                                                    {/* Recordatorio por mail: sólo si hay saldo que recordar. */}
                                                    {Number(data.storeCredit) > 0 && (
                                                        <div className="mr-3">
                                                            <RecordarSaldoButton cedula={cedula} saldo={data.storeCredit} />
                                                        </div>
                                                    )}
                                                    <button type="button" className="btn btn-white" onClick={() => navigateTo(`/userCredit?cedula=${encodeURIComponent(cedula)}`)}>Ver / ajustar crédito</button>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Cuenta del equipo (spec-cuenta-empleados). Sólo para
                                        empleados catalogados, y sólo con cédula: el libro se lleva
                                        POR CÉDULA. Acá se viene a mirar la historia y a cruzar el
                                        mes contra el extracto, no a operar — eso es el panel de la
                                        pantalla de Caja. */}
                                    {cedula && Number(profile.is_employee) === 1 && (
                                        <EmployeeAccountCard cedula={cedula} />
                                    )}

                                    {/* Carrito actual */}
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom"><h6 className="m-0">Carrito actual ({(data.cart || []).length})</h6></div>
                                        <div className="card-body p-0">
                                            <table className="table mb-0">
                                                <thead className="bg-light"><tr><th>Producto</th><th>Código</th><th className="text-center">Cant.</th><th className="text-right">Precio</th><th>Agregado</th></tr></thead>
                                                <tbody>
                                                    {(data.cart || []).length === 0 && (<tr><td colSpan="5" className="text-center text-muted">Carrito vacío.</td></tr>)}
                                                    {(data.cart || []).map((it) => (
                                                        <tr key={it.code}>
                                                            <td>{it.prefix ? `${it.prefix} ` : ''}{it.name}</td>
                                                            <td>{it.code}</td>
                                                            <td className="text-center">{it.quantity}</td>
                                                            <td className="text-right">{money(it.price)}</td>
                                                            <td>{fmtDate(it.created_at)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                {(data.cart || []).length > 0 && (
                                                    <tfoot><tr><td colSpan="3" className="text-right"><strong>Total</strong></td><td className="text-right"><strong>{money(this.cartTotal(data.cart))}</strong></td><td></td></tr></tfoot>
                                                )}
                                            </table>
                                        </div>
                                    </div>

                                    {/* Favoritos */}
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom"><h6 className="m-0">Favoritos ({(data.favorites || []).length})</h6></div>
                                        <div className="card-body p-0">
                                            <table className="table mb-0">
                                                <thead className="bg-light"><tr><th>Producto</th><th>Código</th><th className="text-right">Precio</th><th>Agregado</th></tr></thead>
                                                <tbody>
                                                    {(data.favorites || []).length === 0 && (<tr><td colSpan="4" className="text-center text-muted">Sin favoritos.</td></tr>)}
                                                    {(data.favorites || []).map((it) => (
                                                        <tr key={it.code}>
                                                            <td>{it.prefix ? `${it.prefix} ` : ''}{it.name}</td>
                                                            <td>{it.code}</td>
                                                            <td className="text-right">{money(it.price)}</td>
                                                            <td>{fmtDate(it.created_at)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* Compras */}
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom"><h6 className="m-0">Compras ({(data.orders || []).length})</h6></div>
                                        <div className="card-body p-0">
                                            <table className="table mb-0">
                                                <thead className="bg-light"><tr><th>#</th><th>Fecha</th><th>Estado</th><th>Origen</th><th>Productos</th><th className="text-right">Total</th></tr></thead>
                                                <tbody>
                                                    {(data.orders || []).length === 0 && (<tr><td colSpan="6" className="text-center text-muted">{cedula ? 'Sin compras registradas.' : 'Todavía no compró: las compras se registran contra la cédula.'}</td></tr>)}
                                                    {(data.orders || []).map((o) => (
                                                        <tr key={o.purchaseId}>
                                                            <td>{o.purchaseId}</td>
                                                            <td>{fmtDate(o.date)}</td>
                                                            <td>{GENERAL_STATUS[o.status] || o.status}</td>
                                                            <td>{o.originator || '-'}</td>
                                                            <td>{(o.items || []).map((l) => `${l.name} ×${l.quantity}`).join(', ') || '-'}</td>
                                                            <td className="text-right">{money(o.total)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {/* Juegos usados que trajo el cliente (ENI-203). Dos ejes de
                                        estado: el del juego (disponible/vendido/retirado) y el del
                                        crédito (pendiente/liberado/cancelado). Un juego vendido con
                                        el crédito pendiente es justo el caso que el mostrador
                                        necesita ver. */}
                                    <div className="card card-small mb-4">
                                        <div className="card-header border-bottom"><h6 className="m-0">Juegos usados traídos {data.usedGames == null ? '' : `(${data.usedGames.length})`}</h6></div>
                                        <div className="card-body p-0">
                                            <table className="table mb-0">
                                                <thead className="bg-light"><tr><th>Juego</th><th>Condición</th><th className="text-right">Precio</th><th className="text-right">Crédito</th><th>Estado del juego</th><th>Estado del crédito</th><th>Ingresó</th><th>Venta</th></tr></thead>
                                                <tbody>
                                                    {/* null = la consulta falló. No decir "no trajo ninguno", que sería afirmar
                                                        un hecho falso sobre el crédito que le corresponde al cliente. */}
                                                    {data.usedGames == null && (<tr><td colSpan="8" className="text-center text-muted">{cedula ? 'No se pudieron cargar los juegos usados de este cliente.' : 'Los usados se registran contra la cédula del vendedor: este cliente todavía no tiene.'}</td></tr>)}
                                                    {data.usedGames != null && data.usedGames.length === 0 && (<tr><td colSpan="8" className="text-center text-muted">Este cliente no trajo juegos usados.</td></tr>)}
                                                    {(data.usedGames || []).map((u) => (
                                                        <tr key={u.code}>
                                                            <td>{u.name}</td>
                                                            <td>{conditionLabel(u.condition)}</td>
                                                            <td className="text-right">{money(u.price)}</td>
                                                            <td className="text-right">{money(u.agreedCredit)}</td>
                                                            <td>{stateLabel(u.state)}</td>
                                                            <td>{creditStatusLabel(u.creditStatus)}</td>
                                                            <td>{fmtDate(u.createdAt)}</td>
                                                            <td>{u.soldPurchaseId ? `#${u.soldPurchaseId}` : '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default ClientDetailPage;
